import React from 'react';
import * as T from 'prop-types';
import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import GenericSelectInputField from '../../../commons/form-fields/GenericSelectInputField';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import { getContactFieldPlaceholdersByCountry } from '../../../commons/CountryUtils';
import { validateAndRequiredPhoneNumberUtil } from '../../../commons/utils';

export const BasicInfoAndContactFormSection = (props) => {
    const placeholders = getContactFieldPlaceholdersByCountry(
        props.consultantCountry
    );

    return (
        <div className="max-w-4xl mx-auto bg-white px-6 py-1 md:mt-3 md:mb-6 rounded shadow-md text-sm">
            <HeaderAndError label="Basic Info" />
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="basicInfo.firstName"
                        label="First Name"
                        type="text"
                        required
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="basicInfo.middleName"
                        label="Middle Name"
                        type="text"
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="basicInfo.lastName"
                        label="Last Name"
                        type="text"
                        required
                    />
                </div>
            </div>
            <div className="md:grid md:grid-cols-3 md:gap-6">
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="info.contact.email"
                        label="Email Address"
                        type="text"
                        required
                        validateAndRequiredEmail
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericTextInputField
                        name="info.contact.phone.number"
                        label="Phone"
                        placeholder={placeholders?.phoneNumber}
                        type="text" // to enter special characters for country code
                        required
                        validateUtil={(val) =>
                            validateAndRequiredPhoneNumberUtil(
                                val,
                                props.consultantCountry
                            )
                        }
                    />
                </div>
                <div className="col-span-3 sm:col-span-1">
                    <GenericSelectInputField
                        name="info.contact.phone.type"
                        label="Phone Type"
                        required
                        options={[
                            { key: 'Work', label: 'Work', value: 'Work' },
                            { key: 'Home', label: 'Home', value: 'Home' },
                            { key: 'Mobile', label: 'Mobile', value: 'Mobile' },
                        ]}
                    />
                </div>
            </div>
        </div>
    );
};

BasicInfoAndContactFormSection.propTypes = {
    consultantCountry: T.string,
};
